import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { NAV_SECTIONS } from "@/lib/constants";
import { useAuth } from "@/lib/auth";
import { LogOut, ChevronRight } from "lucide-react";

export default function Sidebar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const handleLogout = () => { logout(); nav("/"); };

  return (
    <aside className="w-[260px] shrink-0 border-r border-[#33291f] bg-[#14100c] h-screen sticky top-0 flex flex-col" data-testid="app-sidebar">
      <div className="px-5 py-5 border-b border-[#33291f]">
        <NavLink to="/app/dashboard" className="flex items-center gap-2.5">
          {user?.logo_url ? (
            <img src={user.logo_url} alt="" className="w-9 h-9 rounded object-cover" />
          ) : (
            <div className="w-9 h-9 rounded flex items-center justify-center text-[#14100c] font-black font-display" style={{ background: `linear-gradient(135deg, ${user?.brand_color || "#d4a574"}, ${user?.brand_color ? user.brand_color + "aa" : "#a67b4c"})` }}>C</div>
          )}
          <div>
            <div className="font-display font-bold text-[15px] tracking-tight">{user?.app_title_override || "The Close Out"}</div>
            <div className="text-[10px] uppercase tracking-[0.15em] text-[#7a6d5a]">Distress Intel</div>
          </div>
        </NavLink>
      </div>

      <nav className="flex-1 overflow-y-auto px-3 py-4 space-y-6">
        {NAV_SECTIONS.map((sec) => (
          <div key={sec.label}>
            <div className="px-2 mb-2 text-[10px] uppercase tracking-[0.18em] text-[#7a6d5a] font-semibold">{sec.label}</div>
            <div className="space-y-0.5">
              {sec.items.filter(i => !i.adminOnly || user?.role === "admin").map((item) => {
                const Icon = item.icon;
                return (
                  <NavLink
                    key={item.to}
                    to={item.to}
                    end={item.to === "/app/admin"}
                    data-testid={item.testid}
                    className={({ isActive }) =>
                      `flex items-center gap-2.5 px-2.5 py-2 rounded text-[13px] group ${
                        isActive
                          ? "bg-[#241d16] text-[#f4ede2] border-l-2 border-[var(--accent-copper)] pl-[8px]"
                          : "text-[#b8ac96] hover:bg-[#1c1712] hover:text-[#f4ede2]"
                      }`
                    }
                  >
                    <Icon size={15} strokeWidth={1.6} />
                    <span className="flex-1 truncate">{item.label}</span>
                  </NavLink>
                );
              })}
            </div>
          </div>
        ))}
      </nav>

      <div className="border-t border-[#33291f] p-3">
        <div className="flex items-center gap-2.5 px-2 py-2">
          <div className="w-8 h-8 rounded-full bg-[#241d16] border border-[#4a3a2b] flex items-center justify-center text-[#d4a574] text-sm font-semibold">
            {user?.full_name?.[0] || "U"}
          </div>
          <div className="flex-1 min-w-0">
            <div className="text-[13px] font-medium truncate">{user?.full_name}</div>
            <div className="text-[10px] text-[#7a6d5a] truncate">{user?.company || user?.email}</div>
          </div>
          <button data-testid="logout-btn" onClick={handleLogout} className="p-1.5 rounded hover:bg-[#241d16] text-[#7a6d5a] hover:text-[#d4a574]">
            <LogOut size={15} />
          </button>
        </div>
      </div>
    </aside>
  );
}
